var map = {
	"./what-is-sms-service-de.html": 2003,
	"./what-is-sms-service-en.html": 2004,
	"./what-is-sms-service-es.html": 2005,
	"./what-is-sms-service-fr.html": 2006,
	"./what-is-sms-service-ja.html": 2007,
	"./what-is-sms-service-pt.html": 2008,
	"./what-is-sms-service-zh.html": 2009
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2002;


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sms-services/help/what-is-sms-service ^\.\/what\-is\-sms\-service\-.*\.html$
// module id = 2002
// module chunks = 0